module.exports = __webpack_public_path__ + "img/1107.ec56f40e.jpg";